<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Persetujuan Rencana Aksi</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Jenis Renja</span>
                                <select class="form-control" v-model="form.renja_setup_id">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_renja_setup" :key="data.renja_setup_id" :value="data.renja_setup_id">{{data.renja_jenis}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">

                                    <th class="text-center" style="width: 5%">Kode</th>
                                    <th class="text-center" style="width: 45%">Program/Kegiatan</th>
                                    <th class="text-center" style="width: 10%">Anggaran</th>
                                    <!-- <th class="text-center" style="width: 0%">Target</th> -->
                                    <th class="text-center" style="width: 30%">Pelaksana</th>
                                    <th class="text-center" style="width: 10%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                    <template v-for="data in list_data">
                                        <tr class="h_isitable cetak_col_kop" :key="data.renja_program_id">
                                            <td class="tabel_center">{{data.program_kode}}</td>
                                            <td class="tabel_center" colspan="5">{{data.program_nama}}</td>
                                        </tr>
                                        <template v-for="data1 in data.kegiatan">
                                            <tr class="h_isitable" :key="data1.kegiatan_id">
                                                <td class="tabel_center">{{data.program_kode}}.{{data1.kegiatan_kode}}</td>
                                                <td class="tabel_center">{{data1.kegiatan_nama}}</td>
                                                <td class="tabel_center">{{format_uang(data1.TOTAL)}}</td>
                                                <!-- <td class="tabel_center text-center" >xxxxx</td> -->
                                                <td class="tabel_center" >
                                                    <ul>
                                                        <template  v-for="data2 in data1.pejabat" >
                                                            <li :key="data2.jabatan_id" v-if="data2.jabatan_nama != null">
                                                                {{data2.jabatan_nama}}&nbsp; 
                                                                <!-- <button type="button" class="btn bg-orange btn-xs " title="Hapus Data">x</button> -->
                                                                <!-- <a href="javascript:void(0);" title="Hapus Data" @click="removeData(data2.sakip_delegasi_lv2_id)">
                                                                    <span class="label label-danger">X</span>
                                                                </a>     -->
                                                            </li>
                                                        </template>
                                                    </ul>
                                                </td>
                                                <td class="tabel_center text-center" >

                                                    <button @click="selectData(data1)" class="btn bg-light-blue btn-xs waves-effect" title="Pilih Rencana/Jadual Pelaksanaan" data-toggle="modal" data-target="#m_listJadual">
                                                        <i class="material-icons" >alarm_add</i>
                                                    </button>
                                                    <!-- &nbsp;
                                                    <button @click="selectData(data1)" class="btn bg-light-green btn-xs waves-effect" title="Pilih Pejabat Pelaksana" data-toggle="modal" data-target="#m_edit_data">
                                                        <i class="material-icons" >account_box</i>
                                                    </button> -->

                                                </td>
                                            </tr>
                                        </template>
                                    </template>

                                </tbody>
                            </table>
                        </div>
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->



                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA PELAKSANA</h4>
                                        </div>
                                        <form @submit.prevent="addData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Pejabat Pelaksana</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control selectku" v-model="form.jabatan_id">
                                                                    <option style="" v-for="data in list_jabatan" :key="data._id" :value="data._id">
                                                                        {{data.jabatan}}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Target</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="form.target" type="number" step="any" class="form-control" placeholder="ex : 100 (Tanpa tanda '%')">
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>
                                           

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="form.keterangan" class="form-control"></textarea>
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">TAMBAH</button>
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST JAUDAL xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_listJadual" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">LIST JADUAL PELAKSANAAN</h4>
                                        </div>
                                        <!-- <form @submit.prevent="addJadual()"> -->
                                            <div class="modal-body">
                                                <br>
                                                <button class="btn bg-light-blue" data-toggle="modal" data-target="#m_addRencanaAksi">
                                                    <!-- <i class="material-icons">av_timer</i> &nbsp; -->
                                                    TAMBAH RENCANA AKSI
                                                </button> 
                                                <br><br>
                                                <div class="table-responsive">
                                                    <table  class="table-kiken" style="width: 100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">
                                                                <th style="width: 85%">Rencana Aksi</th>
                                                                <th style="width: 15%"></th>
                                                            </tr>

                                                         
                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable"   v-for="data in list_rencana" :key="data.sakip_rencana_aksi_lv1_id">
                                                                <td>
                                                                    <ul>
                                                                        <li>{{data.uraian}}</li>
                                                                    </ul>
                                                                </td>
                                                                <td class="text-center">
                                                                    <button @click="selectRencana(data)" class="btn btn-warning btn-xs waves-effect" title="Ubah Data" data-toggle="modal" data-target="#m_editRencana">
                                                                        <i class="material-icons" >create</i>
                                                                    </button>
                                                                    &nbsp;
                                                                   <button @click="removeRencana(data.sakip_rencana_aksi_lv1_id)" class="btn btn-danger btn-xs waves-effect" title="Hapus Data" >
                                                                        <i class="material-icons" >clear</i>
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                            

                                                        </tbody>

                                                    </table>
                                                </div>
                                                <hr>
                                                <button class="btn bg-light-blue" data-toggle="modal" data-target="#m_addJadual">
                                                    ATUR JADUAL PELAKSANAAN
                                                </button>
                                                &nbsp;
                                                <button class="btn bg-light-blue" data-toggle="modal" data-target="#m_addTargetSerapan">
                                                    ATUR RENCANA SERAPAN
                                                </button>
                                                &nbsp;
                                                <button class="btn bg-light-blue" data-toggle="modal" data-target="#m_addTargetKegiatan">
                                                    ATUR RENCANA KEGIATAN
                                                </button>
                                                <br><br>
                                                <div class="table-responsive">
                                                    <table  class="table-kiken" style="width: 100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center text-center">
                                                                <th style="width: 15%">TRIWULAN</th>
                                                                <th style="width: 40%">Bulan</th>
                                                                <th style="width: 15%"></th>
                                                                <th style="width: 15%" class="text-center">Target <br> Serapan (Rp.)</th>
                                                                <th style="width: 15%" class="text-center">Target <br> Realisasi (%)</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">I</td>
                                                                <td>Januari</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jan)"></div></td>
                                                                <td>{{format_uang(serapan.jan)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.jan)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Februari</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.feb)"></div></td>
                                                                <td>{{format_uang(serapan.feb)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.feb)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Maret</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.mar)"></div></td>
                                                                <td>{{format_uang(serapan.mar)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.mar)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">II</td>
                                                                <td>April</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.apr)"></div></td>
                                                                <td>{{format_uang(serapan.apr)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.apr)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Mei</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.mei)"></div></td>
                                                                <td>{{format_uang(serapan.mei)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.mei)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Juni</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jun)"></div></td>
                                                                <td>{{format_uang(serapan.jun)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.jun)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3"  class="text-center">III</td>
                                                                <td>Juli</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jul)"></div></td>
                                                                <td>{{format_uang(serapan.jul)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.jul)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Agustus</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.agu)"></div></td>
                                                                <td>{{format_uang(serapan.agu)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.agu)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>September</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.sep)"></div></td>
                                                                <td>{{format_uang(serapan.sep)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.sep)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">IV</td>
                                                                <td>Oktober</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.okt)"></div></td>
                                                                <td>{{format_uang(serapan.okt)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.okt)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>November</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.nov)"></div></td>
                                                                <td>{{format_uang(serapan.nov)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.nov)}}</td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Desember</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.des)"></div></td>
                                                                <td>{{format_uang(serapan.des)}}</td>
                                                                <td class="text-center">{{format_uang(kegiatan.des)}}</td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>


                                            </div>
                                            <div class="modal-footer">
                                                <!-- <button type="submit" class="btn btn-info waves-effect">TAMBAH</button> -->
                                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        <!-- </form> -->
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST JAUDAL xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH RENCANA AKSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_addRencanaAksi" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-blue">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH RENCANA AKSI</h4>
                                        </div>
                                        <form @submit.prevent="addRencana()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Uraian</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <textarea v-model="rencana.uraian" class="form-control"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn bg-blue waves-effect">TAMBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH RENCANA AKSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT RENCANA AKSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_editRencana" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT RENCANA AKSI</h4>
                                        </div>
                                        <form @submit.prevent="editRencana()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Uraian</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <textarea v-model="rencana.uraian" class="form-control"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn bg-orange waves-effect">EDIT</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT RENCANA AKSI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL UPDATE JAUDAL xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_addJadual" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-blue">
                                            <button @click="emptyDataSerapan()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">ATUR JADUAL PELAKSANAAN</h4>
                                        </div>
                                        <form @submit.prevent="addJadual()">
                                            <div class="modal-body">
                                                <hr>
                                                <div class="table-responsive">
                                                    <table  class="table-kiken" style="width: 100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center text-center">
                                                                <th style="width: 20%">TRIWULAN</th>
                                                                <th style="width: 70%">BULAN</th>
                                                                <th style="width: 10%"></th>
                                                            </tr>

                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">I</td>
                                                                <td>Januari</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.jan" type="checkbox" id="Januari" class="filled-in chk-col-deep-blue">
                                                                    <label for="Januari"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Februari</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.feb" type="checkbox" id="Februari" class="filled-in chk-col-deep-blue">
                                                                    <label for="Februari"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Maret</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.mar" type="checkbox" id="Maret" class="filled-in chk-col-deep-blue">
                                                                    <label for="Maret"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">II</td>
                                                                <td>April</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.apr" type="checkbox" id="April" class="filled-in chk-col-deep-blue">
                                                                    <label for="April"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Mei</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.mei" type="checkbox" id="Mei" class="filled-in chk-col-deep-blue">
                                                                    <label for="Mei"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Juni</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.jun" type="checkbox" id="Juni" class="filled-in chk-col-deep-blue">
                                                                    <label for="Juni"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3"  class="text-center">III</td>
                                                                <td>Juli</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.jul" type="checkbox" id="Juli" class="filled-in chk-col-deep-blue">
                                                                    <label for="Juli"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Agustus</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.agu" type="checkbox" id="Agustus" class="filled-in chk-col-deep-blue">
                                                                    <label for="Agustus"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>September</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.sep" type="checkbox" id="September" class="filled-in chk-col-deep-blue">
                                                                    <label for="September"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">IV</td>
                                                                <td>Oktober</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.okt" type="checkbox" id="Oktober" class="filled-in chk-col-deep-blue">
                                                                    <label for="Oktober"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>November</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.nov" type="checkbox" id="November" class="filled-in chk-col-deep-blue">
                                                                    <label for="November"></label>
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Desember</td>
                                                                <td class="text-center">
                                                                    <input v-model="jadual.des" type="checkbox" id="Desember" class="filled-in chk-col-deep-blue">
                                                                    <label for="Desember"></label>
                                                                </td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn bg-blue waves-effect">SIMPAN</button>
                                                <button @click="emptyDataSerapan()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL UPDATE JAUDAL xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL UPDATE TARGET SERAPAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_addTargetSerapan" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-blue">
                                            <button @click="emptyDataSerapan()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">ATUR TARGET SERAPAN</h4>
                                        </div>
                                        <form @submit.prevent="addRealisasi()">
                                            <div class="modal-body">
                                                <hr>
                                                <div class="table-responsive">
                                                    <table  class="table-kiken" style="width: 100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center text-center">
                                                                <th style="width: 15%">TRIWULAN</th>
                                                                <th style="width: 55%">BULAN</th>
                                                                <th style="width: 15%"></th>
                                                                <th style="width: 15%">TARGET <br> SERAPAN</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">I</td>
                                                                <td>Januari</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jan)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.jan" type="number" step="any" :disabled="check_serapan(jadual.jan)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Februari</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.feb)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.feb" type="number" step="any" :disabled="check_serapan(jadual.feb)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Maret</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.mar)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.mar" type="number" step="any" :disabled="check_serapan(jadual.mar)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">II</td>
                                                                <td>April</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.apr)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.apr" type="number" step="any" :disabled="check_serapan(jadual.apr)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Mei</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.mei)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.mei" type="number" step="any" :disabled="check_serapan(jadual.mei)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Juni</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jun)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.jun" type="number" step="any" :disabled="check_serapan(jadual.jun)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3"  class="text-center">III</td>
                                                                <td>Juli</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jul)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.jul" type="number" step="any" :disabled="check_serapan(jadual.jul)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Agustus</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.agu)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.agu" type="number" step="any" :disabled="check_serapan(jadual.agu)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>September</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.sep)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.sep" type="number" step="any" :disabled="check_serapan(jadual.sep)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">IV</td>
                                                                <td>Oktober</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.okt)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.okt" type="number" step="any" :disabled="check_serapan(jadual.okt)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>November</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.nov)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.nov" type="number" step="any" :disabled="check_serapan(jadual.nov)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Desember</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.des)"></div></td>
                                                                <td>
                                                                    <input v-model="serapan.des" type="number" step="any" :disabled="check_serapan(jadual.des)">
                                                                </td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn bg-blue waves-effect">SIMPAN</button>
                                                <button @click="emptyDataSerapan()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL UPDATE TARGET SERAPAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL UPDATE TARGET KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_addTargetKegiatan" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-blue">
                                            <button @click="emptyDataSerapan()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">ATUR TARGET KEGIATAN</h4>
                                        </div>
                                        <form @submit.prevent="addKegiatan()">
                                            <div class="modal-body">
                                                <hr>
                                                <div class="table-responsive">
                                                    <table  class="table-kiken" style="width: 100%">
                                                        <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center text-center">
                                                                <th style="width: 15%">TRIWULAN</th>
                                                                <th style="width: 55%">BULAN</th>
                                                                <th style="width: 15%"></th>
                                                                <th style="width: 15%">TARGET <br> SERAPAN</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">I</td>
                                                                <td>Januari</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jan)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.jan" type="number" step="any" :disabled="check_serapan(jadual.jan)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Februari</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.feb)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.feb" type="number" step="any" :disabled="check_serapan(jadual.feb)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Maret</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.mar)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.mar" type="number" step="any" :disabled="check_serapan(jadual.mar)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">II</td>
                                                                <td>April</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.apr)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.apr" type="number" step="any" :disabled="check_serapan(jadual.apr)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Mei</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.mei)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.mei" type="number" step="any" :disabled="check_serapan(jadual.mei)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Juni</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jun)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.jun" type="number" step="any" :disabled="check_serapan(jadual.jun)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3"  class="text-center">III</td>
                                                                <td>Juli</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.jul)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.jul" type="number" step="any" :disabled="check_serapan(jadual.jul)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Agustus</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.agu)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.agu" type="number" step="any" :disabled="check_serapan(jadual.agu)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>September</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.sep)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.sep" type="number" step="any" :disabled="check_serapan(jadual.sep)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td rowspan="3" class="text-center">IV</td>
                                                                <td>Oktober</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.okt)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.okt" type="number" step="any" :disabled="check_serapan(jadual.okt)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>November</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.nov)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.nov" type="number" step="any" :disabled="check_serapan(jadual.nov)">
                                                                </td>
                                                            </tr>
                                                            <tr class="h_isitable" >
                                                                <td>Desember</td>
                                                                <td class="text-center"><div v-html="check_jadual(jadual.des)"></div></td>
                                                                <td>
                                                                    <input v-model="kegiatan.des" type="number" step="any" :disabled="check_serapan(jadual.des)">
                                                                </td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn bg-blue waves-effect">SIMPAN</button>
                                                <button @click="emptyDataSerapan()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL UPDATE TARGET KEGIATAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>



<script>

    const ADD_URL = URL_APP+'api/v1/sakip_delegasi_lv2/';
    const ADD_URL_RA = URL_APP+'api/v1/sakip_ra_lv1/';


    const ADD_URL_SETUP_RENSTRA = URL_APP+'api/v1/planning_renja_setup/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';

    const URL_JABATAN = URL_APP+'api/v1/simpeg_jabatan/';



    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    jabatan_id : '',
                    target : 0,
                    keterangan : '',

                    renja_kegiatan_id : '',

                    renja_setup_id : '',
                    tahun : '',
                    instansi_id : '',
                    unit_kerja : '',
                },

                jadual : {
                    sakip_rencana_aksi_lv1_jadual_id : '',
                    renja_kegiatan_id : '',
                    jan : false,
                    feb : false,
                    mar : false,
                    apr : false,
                    mei : false,
                    jun : false,
                    jul : false,
                    agu : false,
                    sep : false,
                    okt : false,
                    nov : false,
                    des : false,
                },
                serapan : {
                    sakip_rencana_aksi_lv1_realisasi_id : '',
                    renja_kegiatan_id : '',
                    jan : 0,
                    feb : 0,
                    mar : 0,
                    apr : 0,
                    mei : 0,
                    jun : 0,
                    jul : 0,
                    agu : 0,
                    sep : 0,
                    okt : 0,
                    nov : 0,
                    des : 0,
                },
                kegiatan : {
                    sakip_rencana_aksi_lv1_kegiatan_id : '',
                    renja_kegiatan_id : '',
                    jan : 0,
                    feb : 0,
                    mar : 0,
                    apr : 0,
                    mei : 0,
                    jun : 0,
                    jul : 0,
                    agu : 0,
                    sep : 0,
                    okt : 0,
                    nov : 0,
                    des : 0,
                },

                rencana : {
                    sakip_rencana_aksi_lv1_id : '',
                    uraian : '',
                    renja_kegiatan_id : '',
                },

                unit_kerja : '',
                unit_kerja_full : '',
                instansi_id : '',


                list_renja_setup :[],

                list_data : [],
                list_rencana : [],
                list_jadual : {},

                check_data_add : false,
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],
                list_jabatan : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.form.unit_kerja = get_profile.profile.unit_kerja;

            this.form.instansi_id = get_profile.profile.instansi_id;
            this.instansi_id = get_profile.profile.instansi_id;


            this.getDataTahun();
            this.getData();

            localStorage.sidemenu = 'sakip';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                // console.log(this.unit_kerja);
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      renja_setup_id : this.form.renja_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data;
                //   console.log(res_data);
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                // console.log(data);

                this.form.renja_kegiatan_id = data.renja_kegiatan_id;
                this.form.renja_setup_id = data.renja_setup_id;
                this.form.tahun = data.tahun;
                this.form.instansi_id = data.instansi_id;
                this.form.unit_kerja = data.unit_kerja;

                this.rencana.renja_kegiatan_id = data.renja_kegiatan_id;
                this.jadual.renja_kegiatan_id = data.renja_kegiatan_id;
                this.serapan.renja_kegiatan_id = data.renja_kegiatan_id;
                this.kegiatan.renja_kegiatan_id = data.renja_kegiatan_id;


                this.getDataTahun();
                this.getJabatan();
                this.getRencana();
                this.getJadual();
                this.getRealisasi();
                this.getKegiatan();
            },


            removeData : function(id){
                console.log(id);
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_jabatan = [];
                // this.jadual = {
                //     sakip_rencana_aksi_lv1_jadual_id : '',
                //     renja_kegiatan_id : '',
                //     jan : false,
                //     feb : false,
                //     mar : false,
                //     apr : false,
                //     mei : false,
                //     jun : false,
                //     jul : false,
                //     agu : false,
                //     sep : false,
                //     okt : false,
                //     nov : false,
                //     des : false,
                // };
                this.serapan = {
                    sakip_rencana_aksi_lv1_realisasi_id : '',
                    renja_kegiatan_id : '',
                    jan : 0,
                    feb : 0,
                    mar : 0,
                    apr : 0,
                    mei : 0,
                    jun : 0,
                    jul : 0,
                    agu : 0,
                    sep : 0,
                    okt : 0,
                    nov : 0,
                    des : 0,
                };
                this.kegiatan = {
                    sakip_rencana_aksi_lv1_kegiatan_id : '',
                    renja_kegiatan_id : '',
                    jan : 0,
                    feb : 0,
                    mar : 0,
                    apr : 0,
                    mei : 0,
                    jun : 0,
                    jul : 0,
                    agu : 0,
                    sep : 0,
                    okt : 0,
                    nov : 0,
                    des : 0,
                };



                this.getJadual();
                this.list_rencana = [];
            },


            emptyDataSerapan : function(){
                this.getJadual();
                this.list_rencana = [];
            },

        //TAMBAHAN
            getSetupRenstra : function(){
                fetch(ADD_URL_SETUP_RENSTRA, {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        tahun : this.form.tahun,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_renja_setup = res_data;

                    if (res_data.length <= 0) {
                        this.form.renja_setup_id = '';
                        this.check_data_add = false;
                    }else{
                        this.form.renja_setup_id = res_data[0].renja_setup_id
                        this.getData();
                    }

                    // console.log(res_data[0]);



                })
            },
            getJabatan : function(){
                fetch(URL_JABATAN+'get_jabatan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify({
                        instansi_id : this.instansi_id
                    })
                }).then((res)=> res.json()).then((res_data)=>{
                    // console.log(res_data);
                    this.list_jabatan = res_data;
                })
            },
            getRencana : function(){
                fetch(ADD_URL_RA+'readData', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.rencana)
                }).then((res)=> res.json()).then((res_data)=>{
                    // console.log(res_data);
                    this.list_rencana = res_data;
                })
            },
            addRencana : function(){
                fetch(ADD_URL_RA+'createData', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.rencana)
                }).then((res)=> res.json()).then((res_data)=>{
                    // console.log(res_data);
                    this.getRencana();
                    this.alertku("success", "Berhasil Mengubah Data!");
                    // this.list_jabatan = res_data;
                })
            },
            editRencana : function(){
                fetch(ADD_URL_RA+'updateData', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.rencana)
                }).then((res)=> res.json()).then((res_data)=>{
                    this.getRencana();
                    this.alertku("success", "Berhasil Mengubah Data!");
                })
            },
            removeRencana : function(id){
                fetch(ADD_URL_RA+'deleteData', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify({
                        id : id
                    })
                }).then((res)=> res.json()).then((res_data)=>{
                    this.getRencana();
                    this.alertku("success", "Berhasil Menghapus Data!");
                })
            },
            selectRencana : function(data){
                this.rencana = {
                    sakip_rencana_aksi_lv1_id : data.sakip_rencana_aksi_lv1_id,
                    uraian : data.uraian,
                    renja_kegiatan_id : data.renja_kegiatan_id,
                };
            },

            getJadual : function(){
                fetch(ADD_URL_RA+'readDataJadual', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.rencana)
                }).then((res)=> res.json()).then((res_data)=>{
                    this.jadual = res_data
                    // console.log(this.jadual);
                    // this.list_rencana = res_data;
                })
            },
            check_jadual : function(data){
                if (data == null || data == undefined || data == ''|| data == false|| data == 0) {
                    return `<i class="material-icons" style="color:red;">remove</i>`
                }else{
                    return `<b><i class="material-icons" style="color:green;">done</i></b>`
                }
            },
            addJadual : function(){
                fetch(ADD_URL_RA+'createDataJadual', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.jadual)
                }).then((res)=> res.json()).then((res_data)=>{
                    console.log(res_data);
                    this.getJadual();
                    this.alertku("success", "Berhasil Menambah Data!");
                })
            },

            getRealisasi : function(){
                fetch(ADD_URL_RA+'readDataRealisasi', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.rencana)
                }).then((res)=> res.json()).then((res_data)=>{
                    this.serapan = res_data
                    // console.log(this.jadual);
                    // this.list_rencana = res_data;
                })
            },
            check_serapan : function(data){
                if (data == null || data == undefined || data == ''|| data == false|| data == 0) {
                    return true
                }else{
                    return false
                }
            },
            addRealisasi : function(){
                fetch(ADD_URL_RA+'createDataRealisasi', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.serapan)
                }).then((res)=> res.json()).then((res_data)=>{
                    console.log(res_data);
                    this.getJadual();
                    this.alertku("success", "Berhasil Menambah Data!");
                })
            },

            getKegiatan : function(){
                fetch(ADD_URL_RA+'readDataKegiatan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.kegiatan)
                }).then((res)=> res.json()).then((res_data)=>{
                    this.kegiatan = res_data
                    // console.log(this.jadual);
                    // this.list_rencana = res_data;
                })
            },
            check_kegiatan : function(data){
                if (data == null || data == undefined || data == ''|| data == false|| data == 0) {
                    return true
                }else{
                    return false
                }
            },
            addKegiatan : function(){
                fetch(ADD_URL_RA+'createDataKegiatan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara ' + localStorage.token 
                    },
                    body : JSON.stringify(this.kegiatan)
                }).then((res)=> res.json()).then((res_data)=>{
                    console.log(res_data);
                    this.getJadual();
                    this.alertku("success", "Berhasil Menambah Data!");
                })
            },




        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.list_data = [];
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;


                this.form.instansi_id = obj.instansi_id;
                this.instansi_id = obj.instansi_id

                this.getDataTahun();
                console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                
                if (this.form.renja_setup_id != '') {
                    this.check_data_add = true;
                }
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    this.form.tahun = this.getTgl().tahun;
                    // console.log(res_data);

                    this.getSetupRenstra();
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (angka == null || angka == '' || angka == undefined) {
                    return angka;
                } else {
                    return (angka).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                }
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
